module.exports = __webpack_public_path__ + "img/best_quality.8bae21a6.png";